module.exports = __webpack_public_path__ + "static/media/levels_1_2.9dfc93df.svg";